'use strict';

export class Header {
    constructor() {
        $('.toggle-menu').on('click', function (event) {
            event.preventDefault();
            $('header').toggleClass('open');
        });

        var $html = $('.region-header-top #block-contact .field--name-body').html();
        $('#block-aba-main-menu ul').prepend('<li class="mobile-only quick-contact-info">' + $html + '</li>');

    }
}
